var allProjectLabels = {};
var projectLimit = 200;

/**
 * Gets projects from the realtime database and updates the project list.
 * Sets the active project if one is not set otherwise it assumes the first
 * active project (isActive) it finds is the active one.
 * @returns {Object.Array<BeamProject>} 
 **/
function getProjectsFromDatabaseAndUpdateProjectList() {
  if(firebase.auth().currentUser === null) {
      return;
  }
  var uid = firebase.auth().currentUser.uid;
  firebase.database().ref('projects/' + uid + '/beam-designer')
    .limitToLast(projectLimit).once('value').then(function(snapshot) {
      var beamProjects = [];
      snapshot.forEach(function(childSnapshot) {
          var childData = childSnapshot.val();
          var project = BeamProject.load(childData);
          beamProjects.push(project);
      });
      return updateProjectList(beamProjects)
    });
}

function updateProjectList(beamProjects) {
    var str = "";
    var activeFound = false;
    if(beamProjects.length <= 0) {
        resetActiveProject();
        return;
    }

    beamProjects.sort(function(a, b){
        if(a.title < b.title) { return -1; }
        if(a.title > b.title) { return 1; }
        return 0;
    });

    for (var key in beamProjects) {
        var proj = beamProjects[key];
        if(typeof proj.isActive !== 'undefined' && proj.isActive === true && activeFound === false) {
            activeFound = true;
            break;
        }
    }

    // if we have beams but nothing is active make the first one active.
    if(activeFound === false) {
        beamProjects[0].isActive = true;
    }

    activeFound = false;

    for (var key in beamProjects) {
        var proj = beamProjects[key];
        if(typeof proj.isActive !== 'undefined' && proj.isActive == true && activeFound == false) {
            activeProject = proj;
            activeFound = true;
        } 

        if(!isProjectVisible(proj)) {
            continue;
        }

        // TODO: temporary
        //if(proj.title !== '755 Washington Area 8' && proj.title !== 'Gradient Test' && proj.title !== 'Broken Load Cases') {
        //    continue
        //}

        try {
            let projStr = '<div class="list-group my-2">'
            if(typeof proj.isActive !== 'undefined' && proj.isActive == true) {
                projStr += '<strong>';
            }

            projStr += '<a class="list-group-item" onclick="loadProjectClicked(\'' + proj.key + '\');">' + proj.title;
            projStr += '<div><small>' + proj.shapeName + ' ' + proj.designTypeStr + '</small></div>';
            projStr += '<div class="text-muted small"><em>Created ' + timeago().format(proj.createdAt) + '</em>';
            projStr += '</div>';
            if(typeof proj.isActive !== 'undefined' && proj.isActive == true) {
                projStr += '</strong>';
            }
            projStr += '</a></div>';
            proj.tags.forEach(function(e) {
                if(!(e in allProjectLabels)) {
                allProjectLabels[e] = {enabled: false};
                }
            });
            str += projStr;
        } catch(error) {
            console.log(error);
            console.log(proj)
            continue;
        }
    }

    document.getElementById("project-list").innerHTML = str;
    
    document.dispatchEvent(new CustomEvent('project-loaded', { detail: activeProject }))

    updateActiveProjectItem(activeProject);

    updateProjectLabelList();
}

function updateActiveProjectItem(activeProject) {
    $('#active-project-title').html(activeProject.title);
    $('#project-title').html(activeProject.title);
    $('#active-project-shape').html(activeProject.shapeName);
    $('#active-project-design-spec').html(activeProject.designTypeStr);
    $('#active-project-timeago').html("Created " + timeago().format(activeProject.createdAt));
    if(activeProject.isNewProject === true) {
        $('#active-project-needs-saved').removeClass('d-none');
        $('#delete-project').addClass('d-none');
        $('#active-project-timeago').addClass('d-none');
    }

    jQuery(".tm-input").tagsManager('empty');

    // disable event handler while we load up the tag manager.
    jQuery(".tm-input").off('tm:pushed');

    activeProject.tags.forEach(function(e) {
      jQuery(".tm-input").tagsManager('pushTag', e);
      if(!(e in allProjectLabels)) {
        allProjectLabels[e] = {enabled: false};
      }
    });

    // now add the event handler back
    jQuery(".tm-input").on('tm:pushed', function(e, tag) {
      activeProject.tags = jQuery(".tm-input").tagsManager('tags');
      markBeamDesignNeedsSaved();
    });

    configureShapeButton();
    configureMaterialButton();
    configureSpanButton();
    configureLoadButton();
    configureBracingButton();
    configureDesignButton();
    configureLoadPrecision(activeProject.loadPrecision);
    //configureShapeSelector()
    document.dispatchEvent(new CustomEvent('on-update-active-project-item'))
    setUnits();
    resizeCanvasArea();
}

function areAnyFiltersEnabled() {
    for (var key in allProjectLabels) {
        if(allProjectLabels[key].enabled === true) {
            return true
        }
    }
    return false;
}

function areAllFiltersEnabled() {
    for (var key in allProjectLabels) {
        if(allProjectLabels[key].enabled === false) {
            return false
        }
    }
    return true;
}

function isProjectVisible(beamProject) {
    if(areAnyFiltersEnabled() === false) {
        return true;
    }
    for (var key in allProjectLabels) {
        if(allProjectLabels[key].enabled === true) {
            for(var k2 in beamProject.tags) {
                if(beamProject.tags[k2] === key) {
                    return true;
                }
            }
        }
    }

    return false;
}


function updateProjectLabelList() {
    var availableFiltersStr = "";
    var activeFiltersStr = "";

    if(areAnyFiltersEnabled() === true) {
        //show the "All Projects" button
        document.getElementById('all-projects-button').classList.add('d-none');
    } else {
        document.getElementById('all-projects-button').classList.remove('d-none');
    }

    var availableFilters = []
    for (var key in allProjectLabels) {
        var o = allProjectLabels[key];
        if(o.enabled === false) {
            availableFilters.push(key);
        } else {
            activeFiltersStr += '<span class="btn-group" role="group">';
            activeFiltersStr += '<button type="button" class="btn btn-xs btn-success"';
            activeFiltersStr += 'onclick="openAvailableFiltersList();">';
            activeFiltersStr += key + '</button>';
            activeFiltersStr += '<button type="button" class="btn btn-xs btn-success"';
            activeFiltersStr += 'onclick="removeFilter(\'' + key + '\')">';
            activeFiltersStr += '<i class="fa fa-fw fa-times-circle"></i></button>&nbsp;</span>';
        }
    }

    availableFilters.sort(function(a, b){
        if(a.toLowerCase() < b.toLowerCase()) { return -1; }
        if(a.toLowerCase() > b.toLowerCase()) { return 1; }
        return 0;
    });

    for (var i in availableFilters) {
        availableFiltersStr += '<li><a href="#" onclick="addLabelFilter(\'' + availableFilters[i] + '\')">';
        availableFiltersStr += '<i class="fa fa-fw fa-plus-circle icon-hover"></i> ' + availableFilters[i] + '</a>';
        availableFiltersStr += '</li>';
    }

    document.getElementById('label-list-dropdown').innerHTML = availableFiltersStr;
    document.getElementById('active-filters-list').innerHTML = activeFiltersStr;

    if(areAllFiltersEnabled() === true) {
        closeAvailableFiltersList();
    }
}

function openAvailableFiltersList() {
    if(areAllFiltersEnabled() === true) {
        return;
    }
    $('#all-projects-button').dropdown('toggle');
    $('.dropdown-toggle').dropdown('toggle');
    $('#label-list-dropdown').addClass('show');
}

function closeAvailableFiltersList() {
    $('#label-list-dropdown').removeClass('show');
}

function addLabelFilter(label) {
    allProjectLabels[label].enabled = true;
    updateProjectLabelList();
    closeAvailableFiltersList();
    getProjectsFromDatabaseAndUpdateProjectList();
}

function removeFilter(label) {
    allProjectLabels[label].enabled = false;
    updateProjectLabelList();
    closeAvailableFiltersList();
    getProjectsFromDatabaseAndUpdateProjectList();
}


function markBeamDesignNeedsSaved() {
    //console.log('needs saved')
    //console.trace()
    activeProject.isModified = true;
    document.getElementById('active-project-title-needs-saved').classList.remove('d-none');
    document.getElementById('active-project-title-needs-saved').classList.remove('text-success');
    document.getElementById('active-project-title-needs-saved').classList.add('text-danger');
    var str = 'Beam modified, save now?  <i class="fa fa-fw fa-save"></i>';
    document.getElementById('saved-time-ago').innerHTML = str;
}


/**
 * Writes a beam projects to the datastore. If beamProject.key does not exist
 * we generate a new key. otherwise we use the key stored in the project.
 * returns a reference to the updated collection
 * @param {Array.<BeamProject>} beamProjects
 **/
function writeProjects(beamProjects) {
    if(firebase.auth().currentUser === null) {
        return;
    }
    var uid = firebase.auth().currentUser.uid;
    var projects = {};
    beamProjects.forEach(function(project) {
        if(project.key === null) {
            // Get a key for a new Post.
            var newProjectKey = firebase.database().ref().child('projects').push().key;
            project.key = newProjectKey;
        }

        var newShape = {};
        if(typeof project.shape !== 'undefined' && project.shape !== null) {
            Object.keys(project.shape).forEach(function(key) {
                var value = project.shape[key];
                var newKey = key.replace("/", "_over_");
                newShape[newKey] = value;
            });
        }
        project.shape = newShape;

        if(project.beamController) {
            delete project.beamController
        }

        projects['/projects/' + uid + '/beam-designer/' + project.key] = project;
    });
    return firebase.database().ref().update(projects);
}

/**
 * Loads a project by uuid
 * we need to either:
 * 1. swap projects if the current project is not new
 * 2. save the current project if it is new then swap
 *
 * note: we loop over our projects, find the correct project one and load it
 * into the the active project slot.
 *
 **/
function loadProject(key) {
  if(key === null || (typeof key === 'undefined')) {
    saveDesignAndStartNew();
    return;
  }

  var uid = firebase.auth().currentUser.uid;
  firebase.database().ref('projects/' + uid + '/beam-designer')
    .limitToLast(projectLimit).once('value').then(function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        var childData = childSnapshot.val();
        let proj = BeamProject.load(childData);
        if(proj.key === key) {
          activeProject.isActive = false;
          proj.isActive = true;
          writeProjects([activeProject, proj]);
          activeProject = proj;
          configureShapeButton();
          configureMaterialButton();
          configureSpanButton();
          configureLoadButton();
          configureBracingButton();
          configureDesignButton();
          configureLoadPrecision(activeProject.loadPrecision);
          setUnits();
          resizeCanvasArea();
          //setPlySelectorIndex();
          document.dispatchEvent(new CustomEvent('load-project', {detail: proj}))

          $('#design-summary-div').fadeOut('fast');
          $('#plots-div').addClass('d-none');
          $('#beam-reactions-div').fadeOut('fast');
          $('#numerical-results-div').fadeOut('fast');
          $('#results-view-div').fadeOut('fast');
        }
      });
      getProjectsFromDatabaseAndUpdateProjectList();
    });
}

function deleteActiveProject() {
    if(customerGate()) { return; }
    var user = firebase.auth().currentUser;
    firebase.database().ref(
        'projects/' + user.uid + '/beam-designer/' + activeProject.key).remove().then(function() {
            return getProjectsFromDatabaseAndUpdateProjectList();
        });
    }

/**
 * Creates a new beam project and sets it as the activeProject
 **/
function resetBeamModelAndSetActiveProject() {
    var beam = new BeamFlexure();
    var design = new BeamFlexureDesign();
    design.designType = 'LRFD';
    design.loadCombination = lrfdCombinations
    design.loadCases = noCombinations
    design.serviceCases = serviceCases

    var beamTitle = "Untitled Beam"; //$("#active-project-title").text().trim();
    var designConfigurator = new DesignConfigurator(); // temporary
    activeProject = new BeamProject(
      beamTitle, beam, design, designConfigurator.shape, designConfigurator.material);
    activeProject.isActive = true;
    const isLoggedIn = false //firebase.auth().currentUser !== null
    BeamManager.makeDefaultBeam(activeProject, isLoggedIn)
    document.dispatchEvent(new CustomEvent('project-loaded', { detail: activeProject }))
}

function resetActiveProject() {
    resetBeamModelAndSetActiveProject();
    configureShapeButton();
    configureMaterialButton();
    configureSpanButton();
    configureLoadButton();
    configureBracingButton();
    configureDesignButton();
    setUnits();
    updateActiveProjectItem(activeProject);
}

function makeSimpleNewProject() {
    var beam = new BeamFlexure();
    var design = new BeamFlexureDesign();
    design.designType = 'LRFD';
    design.loadCombination = lrfdCombinations
    design.loadCases = noCombinations
    design.serviceCases = serviceCases

    var beamTitle = "Untitled Beam"; 
    var designConfigurator = new DesignConfigurator(); // temporary
    activeProject = new BeamProject(
      beamTitle, beam, design, designConfigurator.shape, designConfigurator.material);
    activeProject.isActive = true;
    BeamManager.makeNewSimpleBeam(activeProject)
    document.dispatchEvent(new CustomEvent('project-loaded', { detail: activeProject }))
    configureShapeButton();
    configureMaterialButton();
    configureSpanButton();
    configureLoadButton();
    configureBracingButton();
    configureDesignButton();
    setUnits();
    updateActiveProjectItem(activeProject);
}

function saveActiveProject() {
    if(customerGate()) { return; }
    var user = firebase.auth().currentUser;
    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() !== null && snapshot.val().isPaying === true) {
            writeProjects([activeProject]);
            document.getElementById('active-project-title-needs-saved').classList.remove('d-none');
            document.getElementById('active-project-title-needs-saved').classList.remove('text-danger');
            document.getElementById('active-project-title-needs-saved').classList.add('text-success');
            var str = 'All changes saved';
            document.getElementById('saved-time-ago').innerHTML = str;
            activeProject.isModified = false;
        } else {
            // we have a customer but they need to finish upgrading
            openFinishUpgradeModal();
            return;
        }
    });
}

function makeCopyOfProject() {
    if(customerGate()) { return; }
    var user = firebase.auth().currentUser;
    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() === null || snapshot.val().isPaying === false) {
            openFinishUpgradeModal();
            return;
        }

        activeProject.isActive = false;
        writeProjects([activeProject]).then(function() {
            var uid = firebase.auth().currentUser.uid;
            firebase.database().ref('projects/' + uid + '/beam-designer/' + activeProject.key)
            .once('value').then(function(snapshot) {
                var childData = snapshot.val();
                let proj = BeamProject.createCopy(childData);
                activeProject.isActive = false;
                proj.isActive = true;
                writeProjects([activeProject, proj]);
                activeProject = proj;
                configureShapeButton(activeProject.shape);
                configureMaterialButton(activeProject.material);
                configureSpanButton();
                configureLoadButton();
                configureBracingButton();
                configureDesignButton();
                setUnits();
                resizeCanvasArea();
            });
            getProjectsFromDatabaseAndUpdateProjectList();
          });
    });
}

function startNewProject() {
    activeProject.isActive = false;
    makeSimpleNewProject();
    $('#modal-new-beam-dialog').modal('hide');
}

function saveDesignAndStartNew() {
    activeProject.isActive = false;
    writeProjects([activeProject]);
    makeSimpleNewProject();
    $('#modal-new-beam-dialog').modal('hide');
}
